export default "__VITE_ASSET__1ba26e9c__"